// extracted by mini-css-extract-plugin
export default {"autocomplete":"styles_autocomplete__sVwMm"};